import { POPOVER_CONTENTS } from './MoreQuickFiltersButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { EditIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import AddQuickFilterButton from './AddQuickFilterButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MoreQuickFiltersPopoverContent = ({
  customPropertyNames,
  maxCustomQuickFilters,
  overflowingQuickFiltersComponents,
  hasDynamicQuickFiltersEnabled,
  setCurrentPopoverContent
}) => {
  const addButtonDisabled = customPropertyNames.length >= maxCustomQuickFilters;
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    margin: "400",
    "data-selenium-test": "MorePopover-container",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      marginBlockEnd: "100",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        marginInlineEnd: hasDynamicQuickFiltersEnabled ? '800' : '0',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.quickFiltersBar.moreFilters"
        })
      }), hasDynamicQuickFiltersEnabled && /*#__PURE__*/_jsxs("div", {
        children: [customPropertyNames.length > 0 && /*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.quickFiltersBar.editQuickFilters"
          }),
          children: /*#__PURE__*/_jsxs(Button, {
            "data-selenium-test": "MorePopover-editFilter",
            size: "sm",
            use: "transparent",
            onClick: () => setCurrentPopoverContent(POPOVER_CONTENTS.EDIT_QUICK_FILTERS),
            children: [/*#__PURE__*/_jsx(EditIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerDataFiltersUI.quickFiltersBar.edit"
            })]
          })
        }), /*#__PURE__*/_jsx(AddQuickFilterButton, {
          disabled: addButtonDisabled,
          setCurrentPopoverContent: setCurrentPopoverContent
        })]
      })]
    }), /*#__PURE__*/_jsx(Flex, {
      gap: "100",
      flexWrap: "wrap",
      maxInlineSize: "500px",
      children: overflowingQuickFiltersComponents
    })]
  });
};
export default MoreQuickFiltersPopoverContent;